<template>
    <div>
        <navigation-bar Close/>
        <div class="order-cancel main">
            <div class="text-center m-3">
                <img src="../../assets/images/dialog-order.svg" class="fixed-w-70">
                <!--todo 已接單文案-->
                <p class="red mt-2"  v-if="isAccepted">店家已準備餐點中</p>
            </div>
            <!--todo 未接單文案-->
            <div class="top-index" v-if="!isAccepted">
                店家可能已開始準備您的訂單。請注意，若店家已接收您的訂單，此筆訂單將無法取消及退款喔。
            </div>
            <!--todo 已接單文案-->
            <div class="top-index" v-else>
                店家已接受訂單，無法退款，若確定要取消訂單則<span class="red">不送餐及不退款</span>，且也<span class="red">無法歸還本次消費使用的優惠票券</span>．若餐點已在運送路途上，可能仍會送達。
            </div>
            <h4>
                請問您為何想取消訂單呢？
            </h4>
            <el-radio-group v-model="cancelItem">
                <el-radio v-for="(item, index) in cancelList" :label="item" class="border-bottom" :key="index">{{item.cancelReason}}</el-radio>
            </el-radio-group>
            <div class="footer-button">
                <el-button type="info" @click.stop="clickCancelOrder">取消訂餐</el-button>
            </div>

            <comm-dialog :value="isShowDialog"
                         :main-content="'確定要取消嗎？提醒您，太常取消訂單，會導致您未來無法使用本服務或受到罰款。'"
                         :isIcon="false"
                         @result="onDialogResult">
            </comm-dialog>

            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true">
            </loading>
        </div>
    </div>

</template>

<script>
    import CommDialog from '@/components/CommDialog.vue';
    export default {
        name: "OrderCancel",
        components: {
            CommDialog,
        },
        data() {
            return {
                isShowDialog: false,
                isLoading: false,
                id: typeof this.$route.params.id === "undefined" ? 0 : Number(this.$route.params.id),
                takeoutStatus: typeof this.$route.params.takeoutStatus === "undefined" ? 0 : Number(this.$route.params.takeoutStatus),
                isAccepted: false,
                cancelList: [
                  {'id': '1', 'cancelReason': '餐點送達時間比預期久'},
                  {'id': '2', 'cancelReason': '忘了使用優惠券'},
                  {'id': '3', 'cancelReason': '想改訂別的'},
                  {'id': '4', 'cancelReason': '重複下訂'},
                  {'id': '5', 'cancelReason': '其他'},
                ],
                cancelItem: {
                  'id': '',
                  'cancelReason': '',
                },
            }
        },
        created() {
          if (this.takeoutStatus === 1 || this.takeoutStatus === 2 || this.takeoutStatus === 3) {
            this.isAccepted = true
          }
        },
        mounted() {

        },
        methods: {
            clickCancelOrder() {
              if (this.cancelItem.cancelReason === "") {
                this.$public.showNotify("請選擇取消訂單原因", false);
                return false
              }

              if (this.isAccepted) {
                this.isShowDialog = true
              } else {
                this.cancelOrder()
              }
            },
            cancelOrder() {
                this.isLoading = true
                this.$http.fetchWithAuth`CancelOrder${{
                    'takeoutId': this.id,
                    'isAccepted': this.isAccepted,
                    'cancelReason': this.cancelItem.cancelReason,
                    'os': this.$http.getOS(),
                }}
              ${json => {
                    if (json.status) {
                        this.$router.go(-1)
                    }
                    this.isLoading = false
                    this.$public.showNotify(json.message, json.status);
                }}`;
            },
            onDialogResult(isSure) {
                if (isSure) {
                  this.cancelOrder()
                  this.isShowDialog = false;
                } else {
                  this.isShowDialog = false;
                }

            },
        }
    }
</script>
<style lang="less" scoped src="../../less/order.less"/>
